import { render, staticRenderFns } from "./customer-note.vue?vue&type=template&id=b86f25a2"
import script from "./customer-note.vue?vue&type=script&lang=js"
export * from "./customer-note.vue?vue&type=script&lang=js"
import style0 from "./customer-note.vue?vue&type=style&index=0&id=b86f25a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports